(function(){
  // Menú móvil
  var burger = document.querySelector('.burger');
  var menu   = document.getElementById('MobileMenu');
  if (burger && menu) {
    burger.addEventListener('click', function(){
      var open = menu.getAttribute('data-open') === 'true';
      menu.setAttribute('data-open', String(!open));
      menu.hidden = open;
      burger.setAttribute('aria-expanded', String(!open));
    });
  }
  // Acordeones de FAQ
  document.querySelectorAll('[data-faq-q]').forEach(function(q){
    q.addEventListener('click', function(){
      var item = q.closest('[data-faq-item]');
      if (item) item.classList.toggle('open');
    });
  });
})();
